import React, { PropsWithChildren } from "react";
//#region props
import { DrawerEntityViewProps } from "models/propTypes/drawerPropTypes";
//#endregion
//#region components
import DrawerEntityViewHeader from "./drawerEntityViewHeader";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const DrawerEntityView: React.FC<PropsWithChildren<DrawerEntityViewProps>> = (props) => {
  const { cardHeader, item, render, reloadDrawerItem, removeDrawerItem, reloadList } = props;

  const getCardHeader = () => {
    if (typeof cardHeader === "function") {
      return cardHeader(item);
    } else {
      return cardHeader;
    }
  };

  return (
    <>
      {cardHeader !== undefined && (
        <Grid container className={cssExports.drawerRightHeader}>
          <DrawerEntityViewHeader>{getCardHeader()}</DrawerEntityViewHeader>
        </Grid>
      )}
      <Grid item container className={cssExports.drawerEntityViewContainer}>
        {render ? render(item, reloadDrawerItem, removeDrawerItem, reloadList) : props.children}
      </Grid>
    </>
  );
};

export default DrawerEntityView;
